import React from 'react';
import footerImage from '../assets/footer.jpg';
import cop from '../assets/cop.jpg'
const Footer = () => {
  return (
    <footer className="footer">
      <img src={footerImage} alt="" width="100%"/>
      <img src={cop} alt="" width="100%"/>

    </footer>
  );
};

export default Footer;
